import type CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import MarketStateDailySnapshotState
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/MarketStateDailySnapshotState';
import { findSubmittableRecommendationStates } from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/_table/fragment/MarketStateSnapshotDateBasedTableRowFragment.utilities';

// Review & Submit uses the same day list as its dialogue: the dates of the month, from today, with a valid
// recommendation of any room type that has no successful submission. A `*` day has no same-room snapshot,
// but it is in the list. No day in the list disables the button.
export const isReviewAndSubmitEnabled = (
	canSubmitPrices: boolean,
	dailySnapshotStates: MarketStateDailySnapshotState[],
	companyHotel: CompanyHotel,
	canViewRecommendations: boolean,
	today: string
): boolean => canSubmitPrices
	&& dailySnapshotStates.some(dailySnapshotState =>
		dailySnapshotState.calendarDay.isCurrentMonth
		&& dailySnapshotState.calendarDay.display >= today
		&& findSubmittableRecommendationStates(dailySnapshotState, companyHotel, canViewRecommendations, today).length > 0);
